import { combineReducers } from '@reduxjs/toolkit';
import { reducer as announcementsReducer } from '@features/announcements/slices/announcementsSlice';
import { devicesAnalysisReducer } from '@features/devicesAnalysis';
import controlCenterReducer from '@features/controlCenter/slices/controlCenterSlice';
import { reducer as debtsAlertReducer } from '@features/debtsAlert/slices/debtsAlertSlice';
import devicesSupportReducer from '@features/deviceSupport/slices/devicesSupport';
import { reducer as maipoReducer } from '@features/distributionMaipo/slices/maipoSlice';
import componentsReducer from '@/slices/components';
import { reducer as GlobalConfig } from '@/slices/config';
import distributionReducer from '@/slices/distribution';
import { reducer as gatesReducer } from '@/slices/gates';
import { reducer as mapReducer } from '@/slices/map';
import stationsReducer from '@/slices/stations';
import modalsReducer from '@/slices/modals';
import gatesInMovementReducer from '@features/gateAdministration/slices/reducer';
import userProfileReducer from '@features/userProfile/slices/userProfileSlice';
import deviceProfileReducer from '@features/deviceProfile/slices/deviceProfileSlice';
import dgaReducer from '@features/dga/slices/dgaSlice';
import { reducer as dashboardReducer } from '@/features/dashboardLayout/slices/sidebarSlice';

const rootReducer = combineReducers({
  map_store: mapReducer,
  global_config: GlobalConfig,
  distribution_store: distributionReducer,
  stations_store: stationsReducer,
  gates_store: gatesReducer,
  components_store: componentsReducer,
  devices_support_store: devicesSupportReducer,
  maipo_sira_store: maipoReducer,
  dga_store: dgaReducer,
  debts_alert_store: debtsAlertReducer,
  control_center_store: controlCenterReducer,
  announcements_store: announcementsReducer,
  devices_analysis_store: devicesAnalysisReducer,
  gates_in_movement_store: gatesInMovementReducer,
  user_profile_store: userProfileReducer,
  device_profile_store: deviceProfileReducer,
  modals_store: modalsReducer,
  dashboard_store: dashboardReducer,
});

export default rootReducer;
